import React from 'react';
import PT from 'prop-types';
import { SideMenu, SideMenuSection, SideMenuSubSection, SideMenuLinkItem, SideMenuTextItem, SideMenuSpacer } from '../toolkit';
import { map } from 'lodash';

const controlsByType = {
    menu: MenuSection,
    politics: SideMenuPolitics,
    businessHours: SideMenuBusinessHours,
    contactDetails: SideMenuContactDetails
};

export function Menu({ appBarId, mainContentId, sections }) {
        return (
            <SideMenu appBarId={appBarId} mainContentId={mainContentId}>
                {
                    map(sections, (section, i) => {
                        let Section = controlsByType[section.type];
                        return <Section key={i} section={section} />;
                    })
                }
            </SideMenu>
        );
}
Menu.propTypes = {
    appBarId: PT.string, // TODO: Define this
    mainContentId: PT.string, // TODO: Define this
    sections: PT.array
};


export function MenuSection({ section }) {
    return (
        <SideMenuSection title={section.title}>
            {/* IMPORTANT: Il doit avoir au moins 1 item sélectionné dans tous le menu pour que le slide fonctionne correctement (Gros bug cave de MD) */}
            { map(section.items, (item, i) => <SideMenuLinkItem key={i} selected={i == "0"} url={item.url}>{item.value}</SideMenuLinkItem>) }
        </SideMenuSection>
    );
}
MenuSection.propTypes = {
    section: PT.shape({
        title: PT.string,
        items: PT.array
    })
};

export function SideMenuPolitics({ section }){
    return (
        <SideMenuSection title={section.title}>
            { map(section.items, (item, i) => <SideMenuLinkItem key={i} url={item.url}>{item.value}</SideMenuLinkItem>) }
        </SideMenuSection>
    );
}
SideMenuPolitics.propTypes = {
    section: PT.shape({
        title: PT.string,
        items: PT.array
    })
};

export function SideMenuBusinessHours({ section }) {
    return <SideMenuSection title={section.title}>
        {map(section.items, (subSection, i) => <SideMenuSubSection key={i} title={subSection.title}>
            {map(subSection.items, (item, i) => <SideMenuTextItem key={i}>{item.value}</SideMenuTextItem>)}
        </SideMenuSubSection>)}
    </SideMenuSection>;
}
SideMenuBusinessHours.propTypes = {
    section: PT.shape({
        title: PT.string,
        items: PT.array
    })
};

export function SideMenuContactDetails({ section }) {
    const phones = section.items.phones;
    const address = section.items.address;

    return (
        <SideMenuSection title={section.title}>
            {map(phones, (phone, i) => <SideMenuTextItem key={i}>{phone.value}</SideMenuTextItem>)}
            
            <SideMenuSpacer />

            <SideMenuTextItem isLtr={true}>{address.address1}</SideMenuTextItem>
            <SideMenuTextItem>{address.address2}</SideMenuTextItem>
            <SideMenuTextItem>{`${address.city} ${address.province} ${address.postalCode}`}</SideMenuTextItem>
        </SideMenuSection>
    );
}
SideMenuContactDetails.propTypes = {
    section: PT.shape({
        title: PT.string, 
        items: PT.shape({
            phones: PT.arrayOf(PT.objectOf(PT.string)),
            address: PT.shape({
                address1: PT.string,
                address2: PT.string,
                city: PT.string,
                province: PT.string, 
                country: PT.string,
                postalCode: PT.string
            })
        })
    })
};

